import React, { useState, useEffect, useRef } from 'react';
import { FaPlayCircle } from 'react-icons/fa';
import './testimonios.css';

const testimonials = [
  {
    type: 'image',
    name: 'Carlos Medina',
    role: 'Estudiante',
    quote: 'Agradezco a Enseñarte por brindarme las herramientas y el acompañamiento necesarios para cumplir mi meta de convertirme en técnico veterinario.',
    image: 'https://ensenarteonline.com.co/images/testimonio1.jpg'
  },

  {
    type: 'video',
    name: 'Camilo',
    role: 'Estudiante',
    quote: 'Mi experiencia con Enseñarte me permitió estudiar sin sacrificar mi trabajo. ¡Gracias por el apoyo constante!',
    video: 'https://ensenarteonline.com.co/videos/testimonio%20camilo.mp4',
    thumbnail: 'https://ensenarteonline.com.co/images/testimonio%20camilo.jpg'
  },

  {
    type: 'video',
    name: 'Graduado 1',
    role: 'Graduado',
    quote: '',
    video: 'https://ensenarteonline.com.co/videos/graduado.mp4'
  },

  {
    type: 'image',
    name: 'Leonor Rojas',
    role: 'Estudiante',
    quote: 'Excelente acompañamiento, materiales prácticos y un equipo profesor que hace la diferencia.',
    image: 'https://ensenarteonline.com.co/images/testimonio2.jpg'
  },

  {
    type: 'video',
    name: 'Leonor Rojas',
    role: 'Estudiante',
    quote: 'Ver mi testimonio en video me motiva aún más. Enseñarte hizo mi sueño posible.',
    video: 'https://ensenarteonline.com.co/videos/leonortestimonio.mp4',
    thumbnail: 'https://ensenarteonline.com.co/images/testimonio%20leonor.jpg'
  },

  {
    type: 'video',
    name: 'Graduado 2',
    role: 'Graduado',
    quote: '',
    video: 'https://ensenarteonline.com.co/videos/graduado2.mp4'
  },

  {
    type: 'image',
    name: 'Mariana Ruiz',
    role: 'Estudiante',
    quote: 'Gracias a Enseñarte por darme la oportunidad de estudiar a la distancia y hacer posible que continúe con mi formación.',
    image: 'https://ensenarteonline.com.co/images/testimonio3.jpg'
  },

  {
    type: 'video',
    name: 'Paula Hernandez',
    role: 'Docente',
    quote: 'En primera persona comparto cómo Enseñarte cambió mi formación profesional gracias a un acompañamiento real.',
    video: 'https://ensenarteonline.com.co/videos/testimonio%20profe.mp4',
    thumbnail: 'https://ensenarteonline.com.co/images/testimonio%20profe.jpg'
  },

  {
    type: 'video',
    name: 'Graduado 3',
    role: 'Graduado',
    quote: '',
    video: 'https://ensenarteonline.com.co/videos/graduado3.mp4'
  }
];



function Testimonios() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState('fade-in');

  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
  const videoRefs = useRef([]);

  const nextTestimonials = () => {
    setFadeClass('fade-out');
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 3) % testimonials.length);
      setPlayingVideoIndex(null);
      setFadeClass('fade-in');
    }, 300);
  };

  const prevTestimonials = () => {
    setFadeClass('fade-out');
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex - 3 + testimonials.length) % testimonials.length);
      setPlayingVideoIndex(null);
      setFadeClass('fade-in');
    }, 300);
  };

  const handlePlayVideo = (index) => {
    setPlayingVideoIndex(index);
  };

  useEffect(() => {
    if (playingVideoIndex === null) return;

    const video = videoRefs.current[playingVideoIndex];
    if (video) {
      try {
        video.muted = false;
        video.volume = 1;
        const playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(() => {});
      } catch (error) {
        // ignore play errors from browser restrictions
      }
    }
  }, [playingVideoIndex]);

  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + 3);
  const totalPages = Math.ceil(testimonials.length / 3);
  const currentPage = Math.floor(currentIndex / 3);
  return (
    <section className="testimonials-section section-animated">
      <div className="testimonials-container">
        <h2>Testimonios</h2>
        <p className="testimonials-description">
  Historias reales de estudiantes que transformaron su educación con nosotros.
</p>
        <div className={`testimonial-grid ${fadeClass}`}>
          {visibleTestimonials.map((item, idx) => (
            <article
              key={currentIndex + idx}
              className={`testimonial-card ${item.type === 'video' ? 'testimonial-card-video' : 'testimonial-card-img'}`}
              style={{ position: 'relative', overflow: 'hidden', border: '2px solid var(--deco-1)', padding: 0 }}
            >
              {item.type === 'image' ? (
                <img
                  src={item.image}
                  alt={`Testimonio ${item.name}`}
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'cover',
                    display: 'block',
                    borderRadius: '14px',
                    transition: 'filter 0.3s',
                    filter: 'brightness(0.5)'
                  }}
                />
              ) : (
                <div className="video-preview-wrapper">
                  {playingVideoIndex === currentIndex + idx ? (
                    <video
                      ref={(el) => (videoRefs.current[currentIndex + idx] = el)}
                      src={item.video}
                      controls
                      autoPlay
                      playsInline
                      preload="metadata"
                      className="testimonial-video"
                    />
                  ) : (
                    <div className="video-preview" onClick={() => handlePlayVideo(currentIndex + idx)}>
                      <video
                        ref={(el) => (videoRefs.current[currentIndex + idx] = el)}
                        src={item.video}
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        className="video-preview-element"
                      />
                      <div className="video-play-button">
                        <FaPlayCircle size={72} />
                      </div>
                    </div>
                  )}
                </div>
              )}
              {item.type === 'image' && (
                <div className="testimonial-overlay active">
                  <div className="quote-wrapper">
                    <p className="testimonial-quote">"{item.quote}"</p>
                  </div>
                  <div className="testimonial-info">
                    <h4>{item.name}</h4>
                    <p className="testimonial-role">{item.role}</p>
                  </div>
                </div>
              )}
            </article>
          ))}
        </div>
        {testimonials.length > 3 && (
          <div className="carousel-controls">
            <button className="carousel-btn prev-btn" onClick={prevTestimonials}>‹ Anterior</button>
            <div className="carousel-indicators">
              {Array.from({ length: totalPages }, (_, i) => (
                <span
                  key={i}
                  className={`indicator ${i === currentPage ? 'active' : ''}`}
                  onClick={() => {
                    setCurrentIndex(i * 3);
                    setPlayingVideoIndex(null);
                  }}
                ></span>
              ))}
            </div>
            <button className="carousel-btn next-btn" onClick={nextTestimonials}>Siguiente ›</button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Testimonios;